import { WE_CHAT_MAIL_CHECK } from '../constants/actionTypes';
import { PENDING, SUCCESS, ERROR } from '../constants/status';

const initialState = {
  isLoading: false,
  fetched: false,
  isLoginAvailable: null, // Represents `isAvailable` from the response
  error: null,
};

export function wechatLoginReducer(state = initialState, action) {
  const { type, response, error } = action;

  switch (type) {
    case `${WE_CHAT_MAIL_CHECK}_${PENDING}`:
      return {
        ...state,
        isLoading: true,
        fetched: false,
        isLoginAvailable: null,
        error: null,
      };

    case `${WE_CHAT_MAIL_CHECK}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        fetched: true,
        isLoginAvailable: response.isAvailable,
        error: null,
      };

    case `${WE_CHAT_MAIL_CHECK}_${ERROR}`:
      return {
        ...state,
        isLoading: false,
        fetched: false,
        isLoginAvailable: null,
        error: error?.message || 'An error occurred',
      };

    default:
      return state;
  }
}
